module.exports = __webpack_public_path__ + "img/about.jpg?3a05431a7b777cb8b10b17d8d15049e7";